import { useTranslation } from 'react-i18next'

import { CalendarIcon } from '@mercai/clever'

import { formatDate, textToSnakeCase } from '@/helpers'

import { CardInfo, CardInfoItemsProps } from '@/components'

import type { CardOrderLogisticStatusHistoryProps } from './card-order-logistic-status-history.type'

export const CardOrderLogisticStatusHistory = ({
  shipmentStatusHistory,
  isLoading,
}: CardOrderLogisticStatusHistoryProps) => {
  const { t: tEnums } = useTranslation('enums')
  const { t } = useTranslation('componentCardsOrderCenterShow')

  const mountStatus = () => {
    const statusList: CardInfoItemsProps[] = []

    if (shipmentStatusHistory) {
      Object.keys(shipmentStatusHistory)?.forEach((status) => {
        statusList.push({
          label: tEnums(`logistic_shipment_status_${textToSnakeCase(status)}`),
          value: formatDate(shipmentStatusHistory[status]),
        })
      })
    }

    return statusList
  }

  const items = mountStatus()

  return (
    <div>
      <CardInfo
        isLoading={isLoading}
        icon={<CalendarIcon />}
        title={t('orderLogisticShipmentStatusHistoryTitle')}
        items={items}
      />
    </div>
  )
}
